import formContentComponent from './index.vue'

const formContent = {
    install : (Vue) => {
        Vue.component('formContent', formContentComponent);
    }
}

export default formContent



// WEBPACK FOOTER //
// ./src/base/form/index.js